import { render } from "./DocumentosTabela.vue?vue&type=template&id=a843717a&scoped=true"
import script from "./DocumentosTabela.vue?vue&type=script&lang=js"
export * from "./DocumentosTabela.vue?vue&type=script&lang=js"

import "./DocumentosTabela.vue?vue&type=style&index=0&id=a843717a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a843717a"]])

export default __exports__